<template>
	<div>
		<table>
			<thead>
				<tr class="body-text-1">
					<th class="th-question__type" @click="sortColumn('name')">
						<div class="th-sort">
							<span>{{ $t('expenseCategory') }}</span>

							<span v-if="sortedColumn === 'name'">
								<svgicon :name="isSorted ? 'arrowUp' : 'arrowDown'"> </svgicon>
							</span>
						</div>
					</th>
					<th class="th-question__required">
						{{ $t('required') }}
					</th>
					<th class="th-question__actions">{{ $t('actions') }}</th>
				</tr>
			</thead>
			<tbody class="body-text-2">
				<tr class="search-row">
					<td class="td-input">
						<label class="custom-input">
							<svgicon name="search"> </svgicon>
							<input v-model="searchExpenseCategories" />
						</label>
					</td>
					<td class="th-question__required">
						<ja-dropdown
							v-model="isRequiredIndex"
							:label="$t('')"
							:options="requiredOptions"
							name="required"
							size="small"
						></ja-dropdown>
					</td>
					<td class="th-question__actions"></td>
				</tr>
				<tr v-for="(row, index) in displayedData" :key="index">
					<td colspan="3" class="td-input">
						<span class="td-span" @click="toggleAccordion(index)">
							<span
								class="arrow-icon"
								:class="
									expandedRows[index]
										? 'arrow-rotated-open'
										: 'arrow-rotated-close'
								"
							>
								{{ '▲' }}</span
							>
							{{ $t('bucket') + ': ' + row.name }}
						</span>
						<div v-if="expandedRows[index] && !expandedExpenseCategory[index]">
							<table v-for="(bucket, i) in row.cmsExpenseCategories" :key="i">
								<tbody class="body-text-2">
									<tr>
										<td class="th-question__title">
											{{ bucket.name }}
										</td>
										<td class="th-question__required">
											{{ bucket.isMandatory ? $t('Yes') : $t('No') }}
										</td>
										<td class="th-question__actions">
											<button
												class="action-button"
												@click="editRow(bucket, index)"
											>
												<svgicon name="pencil"></svgicon>
											</button>
											<button
												class="action-button"
												@click="openDeleteModal(bucket)"
											>
												<svgicon name="trash"></svgicon>
											</button>
										</td>
									</tr>
								</tbody>
							</table>
						</div>
					</td>
				</tr>
			</tbody>
		</table>
		<ja-pagination
			:current="currentPage"
			:data-per-page="itemsPerPage"
			:data-count="filteredData.length"
			@changePage="setAllPage"
		></ja-pagination>
		<ja-confirm-modal
			:show="showMessageDeletionModal"
			:title="$t('confirmation')"
			:confirm-text="$t('yes')"
			:cancel-text="$t('no')"
			class="confirm-modal--medium"
			@confirm="deleteExpenseCategory()"
			@closeModal="closeMessageDeletionModal()"
			@cancel="closeMessageDeletionModal()"
		>
			<h3 class="body-text-2">
				{{
					$t('deleteMessageCms', {
						title: $t('expenseCategory')
					})
				}}
			</h3>
		</ja-confirm-modal>
	</div>
</template>
<script>
import Pagination from '@/components/AdminSection/elements/Pagination';
import ConfirmModal from '@/components/Modal/ConfirmModal.vue';
import { Dropdown } from '@/components/ui/form';
import '@/components/icons/cms/search';
import '@/components/icons/cms/pencil';
import '@/components/icons/cms/trash';
import '@/components/icons/cms/arrowDown';
import '@/components/icons/cms/arrowUp';

export default {
	components: {
		jaConfirmModal: ConfirmModal,
		jaPagination: Pagination,
		jaDropdown: Dropdown
	},
	props: {
		data: {
			type: Array,
			required: true
		}
	},
	data() {
		return {
			showMessageDeletionModal: false,
			sortedColumn: null,
			sortOrder: 1,
			isSorted: false,
			searchExpenseCategories: '',
			isRequiredIndex: 0,
			currentPage: 1,
			itemsPerPage: 10,
			interestNameIndex: 0,
			dataExpenseCategory: null,
			expandedRows: [],
			expandedExpenseCategory: [],
			requiredOptions: [
				{ name: this.$t('all') },
				{ name: this.$t('yes') },
				{ name: this.$t('no') }
			]
		};
	},
	computed: {
		filteredData() {
			const option = this.requiredOptions[this.isRequiredIndex].name;
			const isAll = option === this.$t('all');
			const isYes = option === this.$t('yes');
			let filteredData = this.data.filter(row => {
				return (
					row.cmsExpenseCategories.filter(category => {
						const nameMatches = category.name
							.toLowerCase()
							.includes(this.searchExpenseCategories.toLowerCase());
						const isMandatory = category.isMandatory;
						const optionMatches =
							isAll || (isYes && isMandatory) || (!isYes && !isMandatory);
						return nameMatches && optionMatches;
					}).length > 0
				);
			});
			if (this.sortedColumn) {
				filteredData = filteredData.sort((a, b) => {
					const fieldA = a[this.sortedColumn].toLowerCase();
					const fieldB = b[this.sortedColumn].toLowerCase();
					return (fieldA > fieldB ? -1 : 1) * this.sortOrder;
				});
			}
			return filteredData;
		},
		displayedData() {
			const start = (this.currentPage - 1) * this.itemsPerPage;
			const filteredData = this.filteredData.slice(
				start,
				start + this.itemsPerPage
			);
			return filteredData;
		},
		totalPages() {
			return Math.ceil(this.data.length / this.itemsPerPage);
		},
		showPagination() {
			return this.totalPages > 1;
		}
	},
	watch: {
		displayedData() {
			this.currentPage = this.currentPage <= 0 ? 1 : this.currentPage;
		}
	},
	mounted() {
		this.dataExpenseCategory = this.data;
		this.expandedRows = this.dataExpenseCategory.map(() => true);
	},
	methods: {
		toggleAccordion(index) {
			this.$set(this.expandedRows, index, !this.expandedRows[index]);
		},
		sortTable() {
			this.sortOrder = this.sortOrder * -1;
			this.sortedColumn = null;
		},
		sortColumn(column) {
			this.sortedColumn = column;
			this.sortOrder = this.sortOrder * -1;
			this.isSorted = !this.isSorted;
		},
		changePage(pageNumber) {
			this.currentPage = pageNumber;
		},
		editRow(row, index) {
			const dataRowEdit = row;
			dataRowEdit.displayName = this.data[index].name;
			this.$emit('editRow', dataRowEdit);
		},
		openDeleteModal() {
			this.showMessageDeletionModal = true;
		},
		setAllPage(page) {
			this.currentPage = page;
		},
		deleteExpenseCategory() {
			this.showMessageDeletionModal = false;
		},
		openMessageDeletionModal() {
			this.showMessageDeletionModal = true;
		},
		closeMessageDeletionModal() {
			this.showMessageDeletionModal = false;
		}
	}
};
</script>
<style lang="scss" scoped>
table {
	width: 100%;
	border-collapse: collapse;
}
.td-input {
	padding: 0;
}
.th-question {
	&__type {
		width: 70%;
	}
	&__required {
		width: 15%;
	}
	&__actions {
		width: 15%;
	}
}
.td-center {
	text-align: center;
	text-align: -webkit-center;
}
.th-sort {
	cursor: pointer;
	display: flex;
	justify-content: space-between;
}

.custom-input {
	display: flex;
	border-radius: 4px;
	border: 1px solid #ddd;
	box-shadow: inset 0 0 5px 0px rgba(0, 0, 0, 0.15);
	padding: 7px 5px;
	margin: 1px;
	gap: 5px;
}

.custom-input input {
	border: none;
	outline: none;
	width: 100%;
}
.custom-input:focus-within {
	outline: 2px solid $hover-state;
	box-shadow: inset 0 0 5px 0px rgba(0, 0, 0, 0.15);
}
.td-span {
	width: 100%;
	display: flex;
	cursor: pointer;
	height: 100%;
	padding: 5px;
	background-color: $selected-option-bgcolor;
}
.action-button {
	background-color: transparent;
	border: none;
	cursor: pointer;
	padding: 0 10px;
}
.arrow-rotated-open {
	transform: rotate(180deg);
}
.arrow-rotated-close {
	transform: rotate(0deg);
}
.arrow-icon {
	width: 30px;
	text-align: center;
	transition: transform 0.2s ease;
}

th,
td {
	border: 1px solid #ddd;
	padding: 8px;
	text-align: left;
}

th {
	background-color: #ffff;
}

::v-deep .dropdown-component label {
	display: none;
}
</style>
